// extracted by mini-css-extract-plugin
module.exports = {"container":"UspList_container__CW_f_","horizontal":"UspList_horizontal__BSDZB","vertical":"UspList_vertical__jOMUf"};